"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var signedRequest = null;
var codedSignedRequest = null;

exports.default = {
    init: function init(_signedRequest) {
        var _atob = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : atob;

        try {
            codedSignedRequest = _signedRequest;
            var signedRequestBase64 = _signedRequest.substr(_signedRequest.indexOf(".") + 1);
            var signedRequestJson = _atob(signedRequestBase64);
            signedRequest = JSON.parse(signedRequestJson);
        } catch (e) {
            codedSignedRequest = null;
            signedRequest = null;
            throw "Invalid signed request";
        }
    },
    getSignedRequest: function getSignedRequest() {
        if (!codedSignedRequest) return null;
        return codedSignedRequest;
    },
    getPageId: function getPageId() {
        if (!signedRequest) return null;
        return signedRequest.page.id;
    },
    isValid: function isValid() {
        return codedSignedRequest !== null;
    }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/FacebookSignedRequest.js
// module id = 1011
// module chunks = 0